import { gql } from "@apollo/client";

export const onboardingChecklistQuery = gql`
  query OnboardingChecklist {
    viewer {
      user {
        orgs {
          edges {
            node {
              id
              onboardingChecklist {
                __typename
                ... on OnboardingChecklist {
                  flexMeetingEnabled {
                    __typename
                    ... on FlexMeetingEnabled {
                      flexMeetingEnabled
                    }
                  }
                  focusTimeEnabled {
                    __typename
                    ... on FocusTimeEnabled {
                      focusTimeEnabled
                    }
                  }
                  lunchEnabled {
                    __typename
                    ... on LunchEnabled {
                      lunchEnabled
                    }
                  }
                  slackEnabled {
                    __typename
                    ... on SlackEnabled {
                      slackEnabled
                    }
                  }
                  hasInvitedTeammate {
                    __typename
                    ... on HasInvitedTeammate {
                      hasInvitedTeammate
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
